module.exports = __webpack_public_path__ + "308603e2a1dab6c12e9c99999a9140ea.png";